import React, { FC } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
} from "@mui/material";
import { useNavigate, useParams } from "react-router";

import { ReactComponent as ArrowDown } from "assets/icons/chevron-down.svg";
import { DrawerOptionsList } from "./drawer.styles";

interface DrawerProps {
  isOpen: boolean;
  onClose: any;
}
export const DrawerComponent: FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const routeParams = useParams<{ state?: string; city?: string }>();

  const buildPath = (path: string): string => {
    if (!routeParams.state || !routeParams.city) return path;
    if (path === '/') return `/${routeParams.state}/${routeParams.city}`;
    return `/${routeParams.state}/${routeParams.city}${path}`;
  };

  const handleNavigation = (route: string) => {
    onClose();
    navigate(buildPath(route));
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <DrawerOptionsList>
        <li onClick={() => handleNavigation("/")}>INICIAL</li>
        <li>
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDown />}
              aria-controls="panl1a-content"
              id="panl1a-content"
            >
              PREFEITURA
            </AccordionSummary>
            <AccordionDetails>
              <ul>
                <li onClick={() => handleNavigation("/prefeito")}>PREFEITO</li>
                <li onClick={() => handleNavigation("/estrutura")}>
                  ESTRUTURA ORGANIZACIONAL
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </li>
        <li onClick={() => handleNavigation("/noticias")}>NOTÍCIAS</li>
        <li onClick={() => handleNavigation("/servicos")}>SERVIÇOS</li>
        <li onClick={() => handleNavigation("/transferencia")}>
          TRANSFERÊNCIA
        </li>
        <li>
          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDown />}
              aria-controls="panl2a-content"
              id="panl2a-content"
            >
              GESTÃO DO PORTAL
            </AccordionSummary>
            <AccordionDetails>
              <ul>
                <li onClick={() => handleNavigation("/mapa-do-site")}>
                  CONTEÚDO DO PORTAL
                </li>
                <li onClick={() => handleNavigation("/prefeitura/estrutura")}>SEP</li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </li>
      </DrawerOptionsList>
    </Drawer>
  );
};
